 import moment from 'moment';
import { useEffect } from 'react';
import { useAdmin } from '../Hooks/useAdmin';
import { useLogin } from '../Hooks/useLogin';
import { useUser } from '../Hooks/useUser';
import { setShowDeactivatedModal } from '../Redux/slices/GlobalModalSlice';
import { setIsLoggedIn } from '../Redux/slices/GlobalSlice';
import { useAppDispatch, useAppSelector } from '../Redux/store';
import { KaziRoles } from '../Types/General';
import { RouteUrls } from './RouteUrls';
 
 export const ProtectedRoute = (props: any) => {
   /* ******************** Hooks ******************** */
   const dispatch = useAppDispatch();
   const { isAdmin } = useAdmin();
   const { isActive, isVerified, isUserLoading, isUserFetching } = useUser();
   const { logout } = useLogin();
   /* ******************** Variables ******************** */
   const globalSlice = useAppSelector(state => state.Global);
   const inactiveUrls = [RouteUrls.Dashboard, RouteUrls.Settings.AccountInfo, RouteUrls.Login, RouteUrls.SignUp]
   /* ******************** Functions ******************** */
   const authenticate = () => {
      const token = localStorage.getItem('token');
      const role = localStorage.getItem('role');
      const expiration = moment(localStorage.getItem('exp'));
      const nonAdminAcessingAdminConsole = role !== KaziRoles.Admin && window.location.pathname.includes('/admin');
      switch(true){
         case expiration.diff(moment().utc(), 'minutes') <= 0:
         case !token:
            logout(window.location.pathname);
            break;
         case nonAdminAcessingAdminConsole:
            logout();
         default:
            break;
      }
      dispatch(setIsLoggedIn(true));
   }
   /* ******************** Effects ******************** */
   useEffect(()=>{
      authenticate();
   }, [globalSlice.isLoggedIn])

   useEffect(()=>{
      const isLoading = isUserLoading || isUserFetching
      const location = window.location.pathname;
      if (location === '/') return
      if (!isLoading && !isAdmin) {
         const inactiveRestrictionUrl = !inactiveUrls.some( u => location.includes(u));
         if (!isActive && inactiveRestrictionUrl ) {
            dispatch(setShowDeactivatedModal(true))
         }
      };
   }, [window.location.href])
   /* ******************** JSX ******************** */
    return (
        <>
        {globalSlice.isLoggedIn && props.children}
        </>
    )
 }